import { Button, useToast } from "@closer/ui";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

import { api, ApiRequestError } from "../../lib/apiClient";

/**
 * Sosyal giriş aksiyonları (CLOS-336).
 *
 * Kayıt ve giriş ekranları AYNI bileşeni kullanır: iki yerde ayrı yazılsaydı biri
 * güncellenir, diğeri unutulurdu.
 */
type Providers = { google: boolean };

export function SocialAuthButtons({ label }: { label: string }) {
  const toast = useToast();
  const [yonlendiriliyor, setYonlendiriliyor] = useState(false);

  const { data: saglayicilar } = useQuery({
    queryKey: ["session", "providers"],
    queryFn: async () => (await api<Providers>("/api/session/providers")).data,
  });

  // Yapılandırılmamış sağlayıcının düğmesi ÇİZİLMEZ: kullanıcıyı çalışmayan bir yola
  // sokmak, hiç göstermemekten kötüdür — hata sağlayıcının ekranında çıkar ve kimse
  // sebebini anlamaz.
  if (!saglayicilar?.google) return null;

  const basla = async () => {
    // Tekrarlı tıklama İKİNCİ bir OAuth turu başlatmamalı: her tur yeni bir state
    // üretir ve öncekini geçersiz kılar, kullanıcı da sebepsiz bir hataya düşer.
    if (yonlendiriliyor) return;
    setYonlendiriliyor(true);

    try {
      const { data: sonuc } = await api<{ url: string }>("/api/session/social", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ provider: "google" }),
      });
      // Hedef YALNIZ sunucudan gelir; istemci bir adres uydurmaz.
      window.location.assign(sonuc.url);
    } catch (error) {
      // Sahte başarı yok: yönlendirme olmadıysa kullanıcı formda kalır ve sebebini görür.
      setYonlendiriliyor(false);
      toast.error(
        error instanceof ApiRequestError
          ? error.message
          : "Google ile bağlantı kurulamadı. Lütfen tekrar deneyin.",
      );
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-3" aria-hidden="true">
        <span className="h-px flex-1 bg-slate-200" />
        <span className="text-xs text-slate-400">veya</span>
        <span className="h-px flex-1 bg-slate-200" />
      </div>
      <Button type="button" variant="secondary" loading={yonlendiriliyor} onClick={basla}>
        {label}
      </Button>
    </div>
  );
}
